import AutocompleteInputController from '../vd-autocomplete/vd-autocomplete-input.controller'

/**
 * Controller for the vd-dropdown-suggestions component that is the content of the vd-dropdown component's
 * popover.
 *
 * @class DropdownSuggestionsController
 * @extends {AutocompleteInputController}
 */
export default class DropdownSuggestionsController extends AutocompleteInputController {
  constructor($q, $scope, $element, $timeout, $window, $log) {
    'ngInject'
    super({ $q, $scope, $element, $timeout, $window, $log })

    this._suggestionListOpen = true
  }

  $onInit() {
    super.$onInit()
    this.data.suggestions = this.suggestions
    this.data.groups = this.groups
    this.data.selected = this.selected
    if (this.prefill && !this.selected) {
      this.data.query = this.prefill
    }
  }

  // ============================== AutocompleteInputController overrides =============================== //

  _select(suggestion) {
    this.onSelect({ $event: { suggestion } })
  }

  _doCreate() {
    this.onCreate({ $event: { query: this.data.query } })
  }

  _initSearchInput() {
    super._initSearchInput()
    this._searchInput[0].focus()
  }
}
